import React from 'react';

class PageHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="pt-3 pb-1 mb-3" style={{marginTop: '-1.5rem', backgroundColor: '#efefef', borderBottom: '1px solid #e9e9e9'}}>
        {this.props.children}
      </div>
    );
  }
}

export default PageHeader;


// WEBPACK FOOTER //
// ./src/components/shared/PageHeader.js